import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class AccountManager extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="header-title">
                        <h2>Account Manager</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">

                        <SNIntro />

                        <p className="p2">
                            {`We are hiring for an `} <b>{`Account Manager`}</b> {`in New York City to manage some of our most strategic clients, as well as work with the General Manager to build out the departmental operations to create an awesome client experience.`}
                        </p>
                        <br/>
                        <p className="p1"><span className="s1"><b>Responsibilities</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                {`Drive partner relationships with Brand & Agency clients to build successful social media campaigns via Social Native's platform on Instagram, Snapchat, YouTube, etc.`}
                            </li>
                            <li className="p3">
                                Advise the partner on social marketing strategy and exeuction.
                            </li>
                            <li className="p3">
                                Proactively identify, develop, and support campaign revenue growth opportunities while building a relationship as a trusted advisor to our partners.
                            </li>
                            <li className="p3">
                                Exceed revenue goals based on amintaining current business and securing upsell / renewal opportunities with current partners.
                            </li>
                            <li className="p3">
                                Maintain high partner satisfaction by project managing all day to day activities while keeping the partner informed of campaign progress, opportunities, and performance.
                            </li>
                            <li className="p3">
                                Address high severity requests with urgency to drive resolution.
                            </li>
                            <li className="p3">
                                Communicate clearly campaign progress to internal and external teams by reviewing forecasted to actual metrics to ensure we exceed partner and company objectives.
                            </li>
                            <li className="p3">
                                Last, success in this role will hinge upon strong cross-functional relationships with internal Social Native stakeholders including Sales, Operations, Support, Product, Tech.
                            </li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Skills & Qualifications</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                {`Proven account management experience where you are defined by your client's success metrics and their satisfaction.`}
                            </li>
                            <li className="p3">
                                Heavy project management experience managing multiple projects at a time while paying strict attention to detail, preferably in a digital account environment.
                            </li>
                            <li className="p3">
                                Experienced in building and maintaining strong, long=lasting client relationships.
                            </li>
                            <li className="p3">
                                Experience in delivering client-focused solutions based on customer needs.
                            </li>
                            <li className="p3">
                                Demonstrated ability to communicate, present and influence credibly and effectively at all levels of the organization, including executive and C-level.
                            </li>
                            <li className="p3">
                                Excellent listening, problem solving, and negotiation skills.
                            </li>
                            <li className="p3">
                                Excellent verbal and written communication skills.
                            </li>
                            <li className="p3">
                                Excellent presentation skills.
                            </li>
                            <li className="p3">
                                Self-started who thrives on innovation and driving ideas forward.
                            </li>
                            <li className="p3">
                                BA/BS degree or equivalent.
                            </li>
                            <li className="p3">
                                Strong knowledge of online advertising landscape - social, influencer marketing, display, programmatic, search, SEM.
                            </li>
                            <li className="p3">
                                Marketing background is a plus.
                            </li>
                            <li className="p3">
                                At least 2 years relevant work experience.
                            </li>
                            <li className="p3">
                                Powerpoint / Keynote, Excel, Word, etc.
                            </li>
                        </ul>

                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/account_manager.js